import log from 'loglevel';
import { ApiService } from './ApiService';
import { Paging } from '@/interfaces/Paging';
import { OffersProgressAndPaging } from '@/interfaces/Offers/OffersProgressAndPaging';
import { ApiEndpoints } from '@/constants/ApiEndpoints';

import { TokenRequiredStrategy } from '../strategies/TokenRequiredStrategy';



class OfferStatusServiceClass extends ApiService {
  
  private OFFERS_PROGRESS_ENDPOINT = ApiEndpoints.OFFERS_PROGRESS;





  constructor() {
    super(TokenRequiredStrategy)
  }





  async getAllOffersInProgress(params: Paging): Promise<OffersProgressAndPaging> {
    try {
      const response = await this.get(this.OFFERS_PROGRESS_ENDPOINT, params);
      return response;
    } catch (error) {
      log.error('Failed to get offers in progress:', error);
      throw error;
    }
  }





  async getAllCompletedOffers(params: Paging): Promise<OffersProgressAndPaging> {
    try {
      const response = await this.get(this.OFFERS_PROGRESS_ENDPOINT, { status: 'completed', ...params });
      return response;
    } catch (error) {
      log.error('Failed to get completed offers:', error);
      throw error;
    }
  }

  
  
  
  
  async getAllExpiredOffers(params: Paging): Promise<OffersProgressAndPaging> {
    try {
      const response = await this.get(this.OFFERS_PROGRESS_ENDPOINT, { status: 'expired', ...params });
      return response;
    } catch (error) {
      log.error('Failed to get expired offers:', error);
      throw error;
    }
  }




}

// Create an instance of the class and export it
const OfferStatusService = new OfferStatusServiceClass();
export { OfferStatusService };
